module.exports = __webpack_public_path__ + "img/announce.f8fee143.svg";